import { NavigationElement } from '../models/navigation-element';

export let NAVIGATION: NavigationElement = {
  name: 'root',
  children: [],
  elements: [],
};
